<!--
 * @Author: Czy
 * @Date: 2024-09-18 13:44:22
 * @FilePath: /ayh-mobile-overseas/src/layouts/default.vue
 *  
-->
<template>
  <wd-config-provider :themeVars="themeVars" :locale="wdLocale" :key="locale">
    <slot />
    <wd-toast />
    <wd-message-box />
    <sub-message />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
import enUS from 'wot-design-uni/locale/lang/en-US'
import zhCN from 'wot-design-uni/locale/lang/zh-CN'
// import AcCustomerFab from '@ued/atomic/lib/components/ac-customer-fab/index.vue'

const { locale } = useI18n()

const wdLocale = computed(() => {
  const currentLocale = locale.value === 'zh-CN' ? zhCN : enUS
  console.log('[wot-design-uni] Locale changed to:', locale.value, currentLocale)
  return currentLocale
})

const themeVars: ConfigProviderThemeVars = {
  // colorTheme: 'red',
  // buttonPrimaryBgColor: '#07c160',
  // buttonPrimaryColor: '#07c160',
}
</script>
